import storage from '../storage';
/*
function getBoolean(value){
  console.log('boolean', value);
}
*/
export default {
  plugin: (store) => {
    store.subscribe((mutation) => {
      if (mutation.type === 'setToken') {
        if (storage.isLSAvailable) {
          localStorage.setItem('authenticationToken', mutation.payload);
        }
      }
      else if (mutation.type === 'resetToken') {
        localStorage.setItem('authenticationToken', '');
      }
    });
  },
  registerListener(store) {
    window.addEventListener('storage', async function (e) {
      switch (e.key) {
        case 'authenticationToken':
          if (e.oldValue === e.newValue) {
            console.log('same token');
          }
          else if (e.newValue !== '') {
            const token = e.newValue
            try {
              await store.dispatch('login', {method: 'token', token})
            } catch (e) {
              console.error('Storage listener login failed', e.message);
            }
          }
          else {
            await store.dispatch('gotoLogin');
            store.commit('resetToken');
          }
          break;
        case 'userCurrentOrgModules':
          store.commit('setUserCurrentOrgModules', e.newValue)
          break;
        case 'userCurrentOrgId':
          store.commit('setUserCurrentOrgId', Number.parseInt(e.newValue))
          break;
        case 'locationSuggestions':
          try {
            store.commit('setLocationSuggestions', JSON.parse(e.newValue))
          } catch (e) {
            console.log('Loading initial location suggestions failed.', e.message)
          }
      }
    });

    // Clear the suggestions in case someone closes a tab before we can register proper blur event to hide suggestions
    window.addEventListener('unload', () => {
      localStorage.removeItem('locationSuggestions')
    })
  },

  /**
   * Check if there are some data already in the local storage and apply them
   * @param store
   */
  loadInitialData(store) {
    const initialSuggestions = localStorage.getItem('locationSuggestions')
    if (initialSuggestions) {
      store.commit('setLocationSuggestions', JSON.parse(initialSuggestions))
    }
  },
}
